export const orderDetails = {
    header: 'Bestellung nachverfolgen',
    quote: 'Angebot',
    subHeader: 'Details zur bestellung',
    hasBeenShipped: 'Dieser Auftrag wurde bereits abgeschlossen',
    orderSummary: 'Bestellübersicht',
    labels: {
        shippingMethod: 'Versand',
        orderNumber: 'Auftragsnummer',
        quoteNumber: 'Angebotsnummer',
        createdAt: 'Bestelldatum',
        quoteCreatedAt: 'Angefragt',
        orderStatus: 'Bestellstatus',
        productionTime: 'Produktionszeit',
        deliveryTime: 'vorraussichtliche Lieferzeit',
        deliveryTimeShort: 'Voraussichtl. Versandzeit',
        deliveryAndProductionTime: 'Voraussichtl. Gesamtlieferzeit',
        shippingAddress: 'Lieferadresse',
        billingAddress: 'Rechungsadresse',
        name: 'Name',
        email: 'E-Mail',
        address: 'Adresse',
        city: 'Ort',
        country: 'Land',
        paymentMethod: 'Zahlungsmethode',
        items: 'Bestellpositionen',
        summary: 'Zusammenfassung',
        positionPrice: 'Gesamtpreis (ohne Versand)',
        shippingPrice: 'Versandkosten',
        amountTotal: 'Zahlungsbetrag Gesamt',
        cartSum: 'Summe',
    },
    businessDays: '0 Arbeitstage | 1 Arbeitstag | {n} Arbeitstage ',
    regularDays: '0 Tage | 1 Tag | {n} Tage ',
    actions: {
        reOrder: 'Erneut bestellen',
        payNow: 'Jetzt zahlen',
        orderNow: 'Jetzt beauftragen',
    },
    reOrderModal: {
        headline: 'Auftrag {orderNumber} erneut Bestellen?',
        nItems: '0 Teile | Ein Bauteil | {n} Bauteile',
    },
};
